if (!customElements.get('code-filters-state')) {
  customElements.define(
    'code-filters-state',
    class CodeFiltersState extends HTMLElement {
      connectedCallback() {
        const {
          reset: [reset],
          remove: removeButtons = [],
        } = codeGetTargets(this);

        const sectionId = this.closest('product-collection').getAttribute('data-section-id');

        this.productsUpdateUnsubscribe = subscribe('productsUpdate', ({ sections }) => {
          const section = sections[sectionId];

          if (section) {
            const source = new DOMParser()
              .parseFromString(section, 'text/html')
              .querySelector(this.tagName.toLowerCase());

            if (source) {
              this.replaceWith(source);
            }
          }

          this.toggleAttribute('data-loading', false);
        });

        reset.addEventListener('click', async (event) => {
          event.preventDefault();

          this.toggleAttribute('data-loading', true);

          const searchParams = [
            document.querySelector('sort-form form'),
            document.querySelector(`form[action="${routes.search_url}"]`),
          ]
            .filter(Boolean)
            .map(/** @param {HTMLFormElement} f */ (f) => new URLSearchParams(new FormData(f)).toString())
            .filter(Boolean)
            .join('&');

          const sections = await fetch(`${window.location.pathname}?sections=${sectionId}&${searchParams}`).then((r) =>
            r.json(),
          );

          publish('productsUpdate', { sections });

          history.pushState(
            { searchParams },
            '',
            `${window.location.pathname}${
              searchParams.includes('?') || !searchParams ? searchParams : '?'.concat(searchParams)
            }`,
          );
        });

        removeButtons.forEach((element) => {
          element.addEventListener('click', async (event) => {
            const urlToRemove = new URL(`${window.location.origin}${element.dataset.urlToRemove}`);

            event.preventDefault();

            urlToRemove.searchParams.append('sections', sectionId);

            publish('productsUpdate', {
              sections: await fetch(urlToRemove.toString()).then((response) => response.json()),
            });

            /**
             * Remove or update the search parameter.
             */
            const searchParams = new URLSearchParams(window.location.search);

            Array.from(searchParams.keys()).forEach((key) => {
              if (key.startsWith(element.dataset.filterParamName)) {
                if (urlToRemove.searchParams.has(key)) {
                  searchParams.set(key, urlToRemove.searchParams.get(key));
                  return;
                }

                searchParams.delete(key);
              }
            });

            history.pushState(
              { searchParams: searchParams.toString() },
              null,
              `${window.location.pathname}${searchParams.size ? `?${searchParams.toString()}` : ''}`,
            );
          });
        });
      }

      disconnectedCallback() {
        if (this.productsUpdateUnsubscribe) {
          this.productsUpdateUnsubscribe();
        }
      }
    },
  );
}
